<template>
  <div class="test-result">
    <HeadedContainer>

      <template v-slot:header>
        {{$ml.get(`MEDIA ANALYSIS RESULT`)}}
        <info-tip
          :title="$ml.get(`Insert here the values from your media analysis report. In order to have a correct interpretation of your soil status.Make sure that Extraction Method and Units are correct.`)"
        />
      </template>

      <div class="body">
        <table class="a-table" style="width: 100%;">
          <tr class="head">
            <td>
              {{ $ml.get(`ELEMENT`) }}
            </td>

            <template v-if="form.isExtensions">

              <td>{{$ml.get(`UNIT`)}}</td>
              <td>
                <div class="row">
                  {{$ml.get(`EXTRACTION METHOD`)}}
                  <info-tip
                    :title="$ml.get(`Ask your lab which methods they used for your media analysis. Note: different extraction methods might lead to different interpretation`)"
                  />
                </div>
              </td>
              <td>
                <div class="row">
                  {{ $ml.get(`TEST RESULT`) }}
                </div>
              </td>

            </template>

            <td>
              <div class="row">
                {{ $ml.get(`INTERPRETATION`) }}
              </div>
            </td>
          </tr>

            <h3 class="soil-test-row-header">
              {{ $ml.get(`N-Forms`) }}
            </h3>

            <test-result-row-default
              v-if="!$store.getters['tests/media/excludedNutrients'].includes(item.type) && form.isExtensions"
              v-for="item in nForms"
              :item="item"
              :key="item.type"
            />

            <test-result-row-slidebar
              v-if="!$store.getters['tests/media/excludedNutrients'].includes(item.type) && !form.isExtensions"
              v-for="item in nForms"
              :item="item"
              :key="item.type"
            />

            <h3 class="soil-test-row-header">
              {{ $ml.get(`Nutrients`) }}
            </h3>

            <test-result-row-default
              v-if="!$store.getters['tests/media/excludedNutrients'].includes(item.type) && form.isExtensions"
              v-for="item in nutrients"
              :item="item"
              :key="item.type"
            />

            <test-result-row-slidebar
              v-if="!$store.getters['tests/media/excludedNutrients'].includes(item.type) && !form.isExtensions"
              v-for="item in nutrients"
              :item="item"
              :key="item.type"
            />

        </table>
      </div>
    </HeadedContainer>
  </div>
</template>

<script>
import HeadedContainer from '@/components/common/HeadedContainer'
import TestResultRowDefault from './TestResultRowDefault'
import TestResultRowSlidebar from './TestResultRowSlidebar'
import DropList from '@/components/common/DropList'
import { mapGetters } from 'vuex';

export default {
  components: {
    HeadedContainer,
    TestResultRowDefault,
    TestResultRowSlidebar,
    DropList
  },
  computed: {
    ...mapGetters({
      form: 'tests/media/form',
      // labs: 'tests/media/labs',
      // textures: 'tests/media/textures',
    }),
    data() {
      return this.form.data;
    },
    nForms() {
      return this.data.filter(el => el.n_form && el.type != 'NNH2')
    },
    nutrients() {
      return this.data.filter(el => !el.n_form && el.type != 'Al')
    },
    loaded() {
      return this.data.length;
    },

    // nForms() {
    //   return this.data.filter(n => n.n_form);
    // },
    // microNutrients() {
    //   return this.data.filter(n => !n.n_form);
    // },
  }
}
</script>

<style lang="scss" scoped>

.test-result {

  .head {
    td {
      text-align: start;
      padding: 10px;
      padding-bottom: 30px;
      box-sizing: border-box;
      .row {
        display: flex;
        justify-content: flex-start;
      }
      // .ppm {
      //   color: #5EC19B;
      // }
    }
  }

  .soil-test-row-header {
    color: #4C5056;
    font-size: 15px;
    margin-left: 14px;
    padding: 8px 0 0px;
  }

  .body {
    width: 100%;
    padding: 10px !important;
    // overflow-x: auto;

    display: flex;
    flex-direction: column;
    justify-content: flex-start;
    align-items: stretch;
  }
}

</style>
